import React from "react";
import {
    Box,
    useMediaQuery,
} from "@mui/material";
import useStorePriority from "../../../../hooks/useStorePriority";
import { STORE_IMAGES } from "../../../../constants/urls";
import * as S from "../../../../styles/LojasDestaques";

const LojasDestaques = () => {
    const { priorityStores, loadingPriorityStores } = useStorePriority();
    const isMobile = useMediaQuery('(max-width:768px)');
    const stores = priorityStores.slice(0, 16); 

    if (loadingPriorityStores) {
        return <S.LoadingText>Carregando lojas em destaque...</S.LoadingText>;
    }

    // // --- Layout MOBILE: Carrossel (arrastar com o dedo, sem setas) ---
    if (isMobile) {
    const gap = 12;
    // 2 cards inteiros + metade do terceiro (16px de padding + 2 gaps), para indicar que dá para arrastar
    const itemWidth = "min(calc((100vw - 40px) / 2.5), 180px)";

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "1070px",
                margin: "1rem auto",
                position: "relative",
            }}
        >
            <S.LojasTitle>Lojas em Destaque</S.LojasTitle>

            {/* Faixa do carrossel: rolagem nativa, parando no início de um card */}
            <Box
                sx={{
                    width: "100%",
                    overflowX: "auto",
                    scrollSnapType: "x mandatory",
                    scrollPadding: "0 16px",
                    WebkitOverflowScrolling: "touch",
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": { display: "none" },
                    px: 2,
                    boxSizing: "border-box",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        gap: `${gap}px`,
                        width: "max-content",
                        margin: "0 auto",
                    }}
                >
                    {stores.map((store) => {
                        const urlImageStore = `${STORE_IMAGES}${store.slug}.png`;
                        const redirectLink = `https://www.meucupom.com/cupom-desconto-${store.slug}`;
                        const cashback = store.cashbackOn ? store.cashbackPercentage : null;

                        return (
                            <Box
                                key={store.id}
                                component="a"
                                href={redirectLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    flex: "0 0 auto",
                                    width: itemWidth,
                                    height: "140px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "16px",
                                    border: '1px solid #4196CB',
                                    backgroundColor: "#fff",
                                    boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                                    cursor: "pointer",
                                    position: "relative",
                                    scrollSnapAlign: "start",
                                }}
                            >
                                <img
                                    src={urlImageStore}
                                    alt={store.name}
                                    style={{
                                        width: "80%",
                                        height: "auto",
                                        objectFit: "contain",
                                    }}
                                />
                                {cashback && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            bottom: "6px",
                                            color: "#4196CB",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            borderRadius: "10px",
                                            padding: "2px 6px",
                                        }}
                                    >
                                        +{Number(cashback).toFixed(1)}%
                                    </Box>
                                )}
                            </Box>
                        );
                    })}
                </Box>
            </Box>
        </Box>
    );
}

    // --- Layout DESKTOP: Grid normal ---
    return (
        <S.LojasContainer>
            <S.LojasTitle>Lojas em Destaque</S.LojasTitle>
            <S.LojasWrapper>
                <S.LojasGrid>
                    {stores.map((store) => {
                        const urlImageStore = `${STORE_IMAGES}${store.slug}.png`;
                        const redirectLink = `https://www.meucupom.com/cupom-desconto-${store.slug}`;
                        const cashback = store.cashbackOn ? store.cashbackPercentage : null;

                        return (
                            <S.LojaCard
                                as="a"
                                key={store.id}
                                href={redirectLink}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <S.LojaImagem src={urlImageStore} alt={store.name} />
                                {cashback && (
                                    <S.LojaCashback>
                                        {`+${Number(cashback).toFixed(1)}%`}
                                    </S.LojaCashback>
                                )}
                            </S.LojaCard>
                
                        );
                    })}
                </S.LojasGrid>
            </S.LojasWrapper>
        </S.LojasContainer>
    );
};

export default LojasDestaques;
